import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { CheckCircle2, ShieldCheck, Headphones } from "lucide-react";
import "./styles/HeroSection.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const BannerWrapper = styled.div`
  width: 100%;
`;

const AUTOPLAY_MS = 2600;

export default function TutorComponent() {
  // ✅ Memoized slides so they don't re-create every render
  const slides = useMemo(
    () => [
      {
        key: "smart-network",
        title: <>শহরের সব সেরা Tutor, এখন এক জায়গায়।</>,
        subtitle: "সরাসরি কানেকশন",
      },
      {
        key: "zero-commission",
        title: <>Tuition confirm, তুমি শুধু apply করো।</>,
        subtitle: "direct apply - direct connection!",
      },
      {
        key: "choose-tutor",
        title: <>পড়াও অথবা পড়ো — শুরু করো এখনই।</>,
        subtitle: "Easy, Secure, Transparent",
      },
    ],
    [],
  );

  const [active, setActive] = useState(0);
  const timerRef = useRef(null);

  const stop = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const start = () => {
    stop();
    timerRef.current = setInterval(() => {
      setActive((p) => (p + 1) % slides.length);
    }, AUTOPLAY_MS);
  };

  // ✅ Autoplay + clean up
  useEffect(() => {
    start();
    return stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides.length]);

  const goTo = (idx) => {
    setActive(idx);
    // restart timer so user interaction doesn't instantly auto-change
    start();
  };

  return (
    <BannerWrapper>
      <section className="tutor-banner" aria-label="Tutor banner">
        {/* ===== HERO CONTENT WRAPPER =====
            We keep your existing class name for CSS rewrite later.
            But we ensure it works even if CSS is messy:
            - no absolute required
            - safe min-height using inline style fallback
        */}
        <div className="tutor-banner-heading" aria-live="polite">
          {/* ===== CAROUSEL ===== */}
          <div
            className="heroCarousel"
            // fallback so absolute children never collapse container on mobile
            style={{ minHeight: 50 }}
            onMouseEnter={stop}
            onMouseLeave={start}
            onTouchStart={stop}
            onTouchEnd={start}
          >
            {slides.map((s, idx) => {
              const isActive = idx === active;
              return (
                <div
                  key={s.key}
                  className={[
                    "heroSlide",
                    isActive ? "isActive" : "isInactive",
                  ].join(" ")}
                  aria-hidden={!isActive}
                >
                  <h1 className="banner-heading fade-up-2 text-4xl sm:text-6xl md:text-7xl leading-tight mb-5">
                    {s.title}
                  </h1>
                  {/* <p className="sub-tut">{s.subtitle}</p> */}
                </div>
              );
            })}
          </div>

          {/* ===== DOTS ===== */}
          <div className="heroDots" role="tablist" aria-label="Slides">
            {slides.map((s, idx) => {
              const isActive = idx === active;
              return (
                <button
                  key={s.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  aria-label={`Go to slide ${idx + 1}`}
                  className={["heroDot", isActive ? "isActive" : ""].join(" ")}
                  onClick={() => goTo(idx)}
                />
              );
            })}
          </div>
        </div>

        <div className="banner-second-part">
          {/* ===== MICRO TRUST ===== */}
          <div className="baloo-da-2-tutor tutor-buttons">
            <div className="microTrustRow" aria-label="Trust indicators">
              <div className="microTrustChip">
                <CheckCircle2 className="microTrustIcon" strokeWidth={2.4} />
                <span className="microTrustText">Verified tutors</span>
              </div>

              <div className="microTrustChip">
                <ShieldCheck className="microTrustIcon" strokeWidth={2.4} />
                <span className="microTrustText">Nation-wide tuitions</span>
              </div>

              <div className="microTrustChip">
                <Headphones className="microTrustIcon" strokeWidth={2.4} />
                <span className="microTrustText">24/7 Support</span>
              </div>
            </div>
          </div>

          {/* ===== CTA BUTTONS ===== */}
          <div className="baloo-da-2-tutor application-btns">
            <button
              type="button"
              className="tuition-apply-btn-N"
              onClick={() => (window.location.href = "/tuition-board")}
            >
              <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
              <span className="tuition-apply-text">Find Tuitions</span>
            </button>

            <button
              type="button"
              className="tuition-apply-btn-N"
              onClick={() => (window.location.href = "/tutor-board")}
            >
              <i className="fa-solid fa-user-graduate" aria-hidden="true" />
              <span className="tuition-apply-text">Hire Tutor</span>
            </button>

            {/* <button
              type="button"
              className="tuition-apply-btn-N"
              onClick={() => (window.location.href = "/post-tuition")}
            >
              <i className="fa-solid fa-circle-plus" aria-hidden="true" />
              <span className="tuition-apply-text">Post Tuition</span>
            </button> */}
          </div>
        </div>
      </section>
    </BannerWrapper>
  );
}
